var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, Typography } from "@uigovpe/components";
export var SectionDivider = function (_a) {
    var children = _a.children;
    return (_jsx(Divider, __assign({ align: "center", pt: {
            content: {
                style: {
                    // O tema UIGOVPE força #fff aqui; no portal o fundo da página é cinza.
                    backgroundColor: "#F8FAFC",
                },
            },
        } }, { children: _jsx(Typography, __assign({ fontWeight: "medium", size: "sm", textAlign: "center", textTransform: "uppercase", style: { color: "var(--color-text-secondary)" } }, { children: children })) })));
};
